(ns dre.components.pill
  (:require
   [applied-science.js-interop :as j]
   [clojure.string :as str]
   [dre.app.events :as-alias app]
   [dre.app.router :as router :refer [->route ->route-with-query-params]]
   [dre.components.caret :refer [caret]]
   [dre.components.icon :as icon]
   [dre.components.searchbar.subs :as searchbar-subs]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.config :as config]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.page-util :refer [insert-at nbsp]]
   [dre.panels.events :as-alias panels]
   [dre.utils.bem :as bem]
   [dre.utils.query :as query]
   [dre.search-form.render :refer [flat-div]]
   [dre.shared.interface.search.pills :as pills-util]
   [re-frame.core :as rf]
   [reagent.core :as reagent]
   [reagent.dom :as dom]))

(defn- icon-provider
  ([icon-name]
   (icon-provider icon-name nil))
  ([icon-name opts]
   (let [icon-name-str (name icon-name)]
     (if (str/starts-with? icon-name-str "fa-")
       [icon/pill-fa-icon icon-name (merge {:class :pill-fa-icon}
                                           opts)]
       [icon/icon :pill icon-name]))))

(defn- sense-on-click-fn
  [x]
  (rf/dispatch [::panels/set-panel :sense-detail {:modal-params x}]))

(defn wrap-labels
  [element]
  (doseq [el (seq (.getElementsByClassName element "label-text"))]
    (let [span (.-firstChild el)
          ow (j/get-in span [:offsetWidth])
          sw (j/get-in span [:scrollWidth])
          truncated? (< ow sw)
          inner (.-innerHTML span)]
      (when truncated?
        (dom/render
         [tooltip-wrapper inner inner] el)))))

(defn pills
  [_ {:keys [db-root-path]}]
  (let [element (reagent/atom nil)
        caret-idx (atom 0)
        pill-idx (atom 0)
        caret-position (rf/subscribe [::searchbar-subs/caret-position db-root-path])]
    (reagent/create-class
     {:component-will-update #(do
                                (reset! caret-idx 0)
                                (reset! pill-idx 0)
                                (doseq [el (seq (.getElementsByClassName @element "label-text"))]
                                  (dom/unmount-component-at-node el)))
      :component-did-mount
      #(wrap-labels @element)

      :component-did-update
      #(wrap-labels @element) 

      :component-will-unmount
      #(doseq [el (seq (.getElementsByClassName @element "label-text"))]
         (dom/unmount-component-at-node el))

      :reagent-render
      (fn [pills {:keys [indent render-caret? caret-opts focus-on-caret] :as ctx}]
        (let [pills (->> pills
                         pills-util/pills->flats
                         pills-util/main-pills)
              pills (if (and render-caret? @caret-position)
                      (insert-at pills @caret-position [:caret])
                      pills)
              ctx (assoc ctx
                         :icon-provider icon-provider
                         :sense-on-click-fn sense-on-click-fn
                         :source-labels (config/source-labels))
              hiccup (->> pills
                          (#(concat [nil] % [nil]))
                          (partition 3 1)
                          (map (fn [[prevpill pill nextpill]]
                                 (when (not= pill :caret)
                                   [:<>
                                    (when indent " \u21B3 ")
                                    [flat-div pill prevpill nextpill ctx]])))
                          (filter some?))
              hiccup (if-not render-caret?
                       hiccup
                       (cons [caret (assoc caret-opts :i 0)]
                             (interleave hiccup
                                         (map (fn [i] [caret (assoc caret-opts :i i)]) (range 1 (inc (count pills)))))))]
          [:div.pills-container
           {:ref #(reset! element %)
            :class (when render-caret? :pills-container--no-gap)
            :on-click (or focus-on-caret (constantly nil))}
           (->> hiccup
                (map (fn [x]
                       ; TODO: find a better solution
                       (let [i (if (= (first x)
                                      caret)
                                 (do
                                   @caret-idx
                                   (swap! caret-idx inc))
                                 (do
                                   @pill-idx
                                   (swap! pill-idx inc)))]
                         [:<>
                          {:key (str i "-" (hash x))}
                          x])))
                doall)]))})))

; TODO: magnifying glass alignment in multi-line queries
; TODO: jigsaw pills are not shown like jigsaw, e.g. in title
(defn readonly-pills
  [input-pills order question viewtype opts]
  (let [input-pills-nn (remove nil? input-pills)
        {:keys [:hide-controls?]} opts
        search-query (cond-> {:query/type :articles
                              :query/pills input-pills-nn}
                       (not (nil? order)) (assoc :query/order order)
                       (not (nil? question)) (assoc :query/question question)
                       (not (nil? viewtype)) (assoc :query/viewtype viewtype))
        route (query/route search-query nil)]
    (if (empty? input-pills-nn)
      [:div
       {:class :subject}
       [:div
        {:class (bem/be :subject :empty)}
        [icon/icon :common :warning]
        nbsp
        [:b [tr "Empty query"]]]]
      [:div
       {:class :subject}
       [:div
        {:class (bem/be :subject :fragment)}
        [pills input-pills-nn]
        (when (not hide-controls?)
          [:div
           {:class (bem/be :subject :actions)}
           [tooltip-wrapper "Search for articles" [:a
                                                   {:href (->route-with-query-params (->route :search) (:query-params route))}
                                                   [icon/fa-icon :magnifying-glass]]]])]])))
